app.config(function ($translateProvider) {
    $translateProvider.translations('en-gb', {
        USER: 'User',
        USERS: 'Users',

        USER_EDIT: 'Edit User',
        USER_LIST: 'Users',
        USER_ADD: 'Add a new User',
        ADD_NEW_USER: 'Add a User',
        NEW_SITE_ACCESS: 'Grant Access to new Sites',
        USER_CREATED: 'User Created',
        NEW_ROW: 'New row',
        USER_UPDATED: 'User Updated',
        ADD_SPECIFIC_SITE_ACCESS: 'Add Specific Site Access',
        EMAIL_IN_USE_WARNING: 'Email Match: Users with shared email addresses will not be able to use SSO login',
        SAVE_ANYWAY: 'Save anyway!?',

        USER_ROLES: 'Roles',
        ALL_ROLES: 'All roles',
        SELECTED_ROLES: 'Selected roles',
        CHANGE_PASSWORD: 'Change password',
        PASSWORD_RESET_REQUEST_SUCCESSFUL: 'Please check your mail for password change instructions.',
        USER_SETTINGS_VIEW: 'User Settings',
        USER_SETTINGS_EDIT: 'Edit User Settings',
        USER_SETTINGS: 'User Settings',
        USER_NOTIFICATION_TYPE: 'Notification method',
        NOTIFICATIONMETHOD: 'Notification method',
        EMAILCONTENTTYPE: 'Email content type',
        EMAIL_CONTENT_TYPE: 'Email content type',
        USER_EMAIL_CONTENT_TYPE: 'Email content type',
        USER_PREFERENCE_ALL: 'all',
        USER_PREFERENCE_NOTIFICATION: 'notification',
        USER_PREFERENCE_EMAIL: 'email',
        USER_PREFERENCE_TEXT: 'text',
        USER_PREFERENCE_HTML: 'html',
        USER_SETTINGS_UPDATED: 'User Settings have been updated',
        USER_PREFERENCE_LOCALE: 'Locale',
        USER_PREFERENCE_NOTIFY_ON_CREATE_JOB: 'Notify on Create Job',
        USER_PREFERENCE_NOTIFY_ON_COMPLETE_PLANNED_JOB: 'Notify on Complete Planned Job',
        USER_PREFERENCE_NOTIFY_ON_COMPLETE_REACTIVE_JOB: 'Notify on Complete Reactive Job',
        USER_PREFERENCE_NOTIFY_ON_COMPLETE_STATUTORY_JOB: 'Notify on Complete Statutory Job',
        USER_PREFERENCE_NOTIFY_ON_COMPLETE_DOC_TYPE_REQUIRE_APPROVAL_JOB: 'Notify when Job Complete with doc type requiring approval',
        USER_PREFERENCE_NOTIFY_ON_UPDATES_WATCHED_JOBS: 'Notify on updates to Watched Jobs',
        USER_PREFERENCE_NOTIFY_ON_UPDATES_WATCHED_QUOTES: 'Notify on updates to Watched Quotes',
        USER_PREFERENCE_NOTIFY_ON_CREATE_QUOTE: 'Notify on Create Quote',
        USER_PREFERENCE_NOTIFY_ON_ACCEPT_QUOTE: 'Notify on Accept Quote',
        USER_PREFERENCE_NOTIFY_ON_PAPERWORK_FOR_REVIEW_ACTION_CREATED: 'Notify on Paperwork for review Action creation',
        WEEKLY_DASHBOARD_REPORT: 'Weekly Dashboard Report',

        THIS_USER_HAS_NO_SITES: 'This user have no access to sites',
        GIVE_ACCESS: 'Give Access',
        CHANGE_SITE_ACCESS: 'Change Site Access',
        GRANT_ACCESS: 'Grant Access',
        REVOKE_ACCESS: 'Revoke Access',
        TO_ALL_ACTIVE_SITES: 'To all active sites',
        SELECT_SPECIFIC_SITES: 'Select specific sites',
        COPY_FROM_USER: 'Copy from user',
        FROM_ALL_SITES_ON_THE_SYSTEM: 'From all sites on the system',
        CONFIRM_AND_FINISH: 'Confirm and finish',
        CONTINUE_AND_CHOOSE_SITES: 'Continue and choose sites',
        AVAILABLE_SITES: 'Available Sites',
        GRANT_ACCESS_TO: 'Grant access Sites',
        MODIFY: 'Modify',
        MODIFY_ACCESS: 'Modify Access',
        REMOVE_SELECTED_SITE_ACCESS: 'Remove ({{ count }} Selected)',

        SITE_PERMISSIONS: 'Site Permissions',
        SITE_PERMISSIONS_LIST: 'Site Permissions',
        USER_PERMISSIONS_LIST: 'User Permissions',
        REPORT_PERMISSIONS_LIST: 'Report Permissions',
        OPERATIVE_PERMISSIONS_LIST: 'Operative Permissions',
        SELECT_PERMISSIONS: 'Select Permissions',
        ADD_PERMISSIONS: 'Add Permissions',
        UPDATE_PERMISSIONS: 'Update Permissions',
        EXPLICIT_PERMISSIONS: 'Explicit Permissions',
        USER_HAS_NO_SITE_ACCESS: 'User has no site access',
        USER_PERMISSIONS: 'User Permissions',
        PERMISSIONS: 'Permissions',
        PERMISSION: 'Permission',
        REMOVE: 'Remove',

        NO_OPERATIVES_ASSIGNED: 'No Operatives Assigned',

        SITE_PERMISSIONS_UPDATED: 'Site Permissions Updated',
        USER_PERMISSIONS_UPDATED: 'User Permissions Updated',
        USER_TOKENS: 'Tokens',
        TOKEN: 'Token',
        TOKENS_LIST: 'Tokens List',
        EXPIRATION_DATE: 'Expiration Date',
        TOKENS_ADD: 'Create a New Token',
        USER_TOKEN_ADD: 'Create Token',
        TOKENS: 'Tokens',
        TOKEN_ADD: 'Create a New Token',
        TOKEN_CREATED: 'Token Created',
        TOKEN_REVOKED: 'Token Revoked',
        STANDARD: 'Standard',
        MERIDIAN: 'Vantify Risk Manager',
        RISKWISE: 'RiskWise',
        ALCUMUS: 'Ligtas',
        PROPERTYPLUS: 'Property Plus',
        PROPERTYPLUS_LIGTAS: 'Property Plus (Ligtas)',
        DATASTATION: 'DataStation',
        USED_TO_SET_API_USER_TYPE: 'Used to set API User type',
        INVALID_USER_TYPE: 'Invalid User Type. You may be attempting to use a user type for a disabled module.',
        USER_TYPE: 'Type',
        INVALID_TOKEN: 'Invalid Token',
        INVALID_TOKEN_NO_SUBMIT: 'Invalid token, unable to submit',
        INVALID_TOKEN_NO_SUBMIT_FEEDBACK: 'Invalid token - Unable to submit feedback',
        ROLES_TO_MANY_MEMBERSHIPS: 'A user has more than 100 site memberships, so please only add or remove 1 role per request.',
        SITE_ACCESS_REMOVED: 'Site Access Removed',
        CONTACT_HAS_NO_EMAIL: 'Users must have at least 1 email address, please add an email address',
        EMAIL_SENT_TO: 'Email sent to',
        EMAIL_NOT_VALID: 'Email address is not valid',
        PHONE_NUMBER_NOT_VALID: 'Telephone number is not valid',

        USER_CREATED_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> created the user.',
        USER_CREATED_SYSTEM_ACTION: 'The system automatically created the user.',
        USER_EDITED_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> updated the user.',
        USER_EDITED_SYSTEM_ACTION: 'The system automatically updated the user.',
        USER_PASSWORD_UPDATED_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> updated this User\'s password.',
        USER_INACTIVE_NOTIFIED_SYSTEM_ACTION: '{{ ::event.metadata.note }}<strong>{{ ::event.metadata.userEmailAddress }}</strong>',
        USER_RESET_PASSWORD_EMAIL_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> sent password reset email.',
        USERNAME_REMINDER_EMAIL_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> sent a Username reminder email.',
        WELCOME_EMAIL_SENT: 'Welcome Email Sent',
        WELCOME_EMAIL_SENT_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> sent a welcome email.',
        USER_INACTIVATED_SYSTEM_ACTION: 'User has been deactivated.',
        USER_EMAIL_MISSING: 'User email is missing.',
        USER_EMAIL_VERIFIED_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> successfully Verified their account.',
        USER_PERMISSIONS_REMOVED_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> removed permissions from the user.',
        USER_PERMISSIONS_ADDED_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> added permissions to the user.',
        PERMISSIONS_REMOVED: 'Permissions Removed',
        PERMISSIONS_ADDED: 'Permissions Added',
        USER_ROLES_REMOVED_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> removed roles from the user.',
        USER_ROLES_ADDED_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> added roles to the user.',
        ROLES_REMOVED: 'Roles Removed',
        ROLES_ADDED: 'Roles Added',
        EMAIL_VERIFIED: 'Email Verified',
        EVENT_EMAIL_VERIFIED: 'Email verified',
        USER_FAILED_EMAIL_VERIFICATION_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> account has been locked due to failed Verification.',
        EMAIL_VERIFICATION_FAILED: 'Email Verification Failed',
        USER_EMAIL_VERIFICATION_CODE_SENT_ACTION: '<strong>{{ ::event._links["user"].title }}</strong> triggered a Verification Code.',
        EMAIL_VERIFICATION_CODE_SENT: 'Verification Code sent to',
        VERIFICATION_CODE_DOES_NOT_MATCH: "There's an issue with the verification code you entered.</br>You have {{attempts}} remaining.</br>Please try again.",
        TOO_MANY_ATTEMPTS_ACCOUNT_LOCKED: 'Too many attempts, account is locked.',
        VERIFICATION_CODE_FAILED_3_TIMES: 'You have entered an incorrect code 3 times, your account has now been locked',
        PLEASE_VERIFY_TEXT: 'Please verify your email address - <strong>{{email}}</strong></br>Check your email, we\'ve sent you a code.',
        PLEASE_CONTACT_HELPDESK: 'Please contact the Vantify CAFM Helpdesk team on</br> {{helpdeskNumber}}',
        CODE_RESENT: 'Code Resent',
        WAIT_30_SECONDS_TO_RESEND_ANOTHER_CODE: 'Please wait 30 seconds to resend another code',
        NEW_CODE_SENT: 'Verification Email Sent',
        EMAIL_ALREADY_VERIFIED: 'Email ALready Verified',
        EMAIL_VERIFICATION_MODULE_DISABLED: 'Email Verification Module Disabled',
        CODE_EXPIRED_REQUEST_NEW_CODE: 'This Code has Expired. Please request a new one.',
        CODE_DOES_NOT_MATCH: 'Code Does Not Match',
        STILL_HAVENT_RECEIVED_CODE: "Haven't received a code? Click",
        TO_RESEND: 'to resend',
        CODE_RESENT_WAIT: 'A new code has been sent,</br>another code can be resent in 00:{{counter}}',
        CODE_RESEND_COUNTDOWN: 'Another code can be resent in 00:{{counter}}',

        ASSOCIATE_DETAILS: 'Associate details',
        DEPARTMENT: 'Department',

        USER_INTEGRATIONS: 'Service Provider Integraitons',
        EMAIL_UPDATE_NOT_ALLOWED: 'Email update not allowed',

        USER_CATEGORY: 'Category',
        USER_CATEGORY_VANTIFY: 'Vantify',
        USER_CATEGORY_CLIENT: 'Client',
        USER_CATEGORY_SERVICE_PROVIDER: 'Service Provider',
        USER_CATEGORY_API_USER: 'API User',
        USER_CATEGORY_OTHER: 'Other',
        USER_CATEGORY_SUBCONTRACTOR: 'Subcontractor',
        USER_OPERATIVE_REMOVAL_WARNING: 'Are you sure you want to perform this action? This will remove all selected Service Providers from the User.',

        MY_DETAILS: 'My Details',
        MY_DETAILS_VIEW: 'My Details',
        DISPLAY_NAME: 'Display Name',
        TELEPHONE_NUMBER: 'Telephone Number',
        MY_DETAILS_EDIT: 'Edit My Details',
        ADD_TELEPHONE_NUMBER: 'Add Telephone Number',
        TOOLTIP_PLEASE_CONTACT_EMAIL_REQUEST_UPDATE: 'Please contact helpdesk.cafm@vantify.com to request an update to these details.',
        USER_DETAILS_UPDATED: 'User Details Updated',
        SEND_WELCOME_EMAIL: 'Send Welcome Email',
        WELCOME_EMAIL_UNAVAILABLE: 'User is not active and cannot be sent a Welcome email.',
        SEND_WELCOME_EMAIL_CONFIRMATION: 'If you continue, the User will be provided the following information:',
        WELCOME_EMAIL_CONFIRMATION_ITEM1: 'URL for the System',
        WELCOME_EMAIL_CONFIRMATION_ITEM2: 'Their Username',
        WELCOME_EMAIL_CONFIRMATION_ITEM3: 'Instructions on how to reset their password',
        SSO_EMAIL_MATCH_SHARED_EMAIL_WARNING: 'Email Match: Users with shared email addresses will not be able to use SSO login'
    });
});
